import { __rest } from 'tslib';
import React from 'react';
import { extractMarginProps, extractDimensionProps } from '@10d/tend-ui-styling';
import { useColor } from '../../theme/Theme.js';
import { Root } from './styled.js';

const Text = React.forwardRef((_a, ref) => {
    var { size = 'medium', uppercase, color, textAlign, fontWeight, className, wordBreak } = _a, props = __rest(_a, ["size", "uppercase", "color", "textAlign", "fontWeight", "className", "wordBreak"]);
    const _color = useColor(color);
    const _b = extractMarginProps(props), { rest: withoutMargins } = _b, margins = __rest(_b, ["rest"]);
    const _c = extractDimensionProps(withoutMargins), { rest } = _c, dimensions = __rest(_c, ["rest"]);
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-text' }, rest, margins, dimensions, { ref: ref, "$uppercase": uppercase, "$size": size, "$color": _color, "$textAlign": textAlign, "$fontWeight": fontWeight, "$wordBreak": wordBreak, className: ['tend-ui-typography-text', className].filter(Boolean).join(' ') })));
});
Text.displayName = 'Text';

export { Text };
//# sourceMappingURL=Text.js.map
